import * as React from 'react';
import { Abo } from '../../api/Abo';
import { IAbo } from '../../api/model/IAbo';
import { AboList } from './AboList';
import { showMessage, useGlobalState } from '../../service/globalState.service';
import { Spinner} from '@fluentui/react-components';
import { endOfMonth, startOfMonth, endOfDay } from '../../utils/time.utils';
import { getRecentlyLinked } from '../../service/recentlyLinked.service';

const { useEffect, useState } = React;


interface AllTasksListProps {
  filter: (abos: IAbo[]) => IAbo[];
  filterStart: Date;
  filterEnd: Date;
}

export const AllTasksList: React.FC<AllTasksListProps> = ({ filter, filterStart, filterEnd }) => {
  const [abos, setAbos] = useState<IAbo[]>([]);
  const [spinner, showSpinner] = useState(false);
  const [recentlyLinked] = useState<IAbo[]>(() => getRecentlyLinked());
  const [{ showAllTasks }] = useGlobalState('settings');

  useEffect(() => {
    requestAbos();
  }, [filterStart, filterEnd]);

  const requestAbos = async () => {
      const { item } = Office.context.mailbox;
      if (!item) return;
      showSpinner(true);
      item.start.getAsync(async r => {
        if (!r.value) return;
        let inProgressQuery = ``;
        if (showAllTasks) {
          if (filterStart && !filterEnd) {
            inProgressQuery = `$filter=EndDate ge ${filterStart.toISOString()}`;
          } 
          else if (!filterStart && filterEnd) {
            inProgressQuery = `$filter=StartDate le ${filterEnd.toISOString()}`;
          }
          else if (filterStart && filterEnd ){
            inProgressQuery = `$filter=StartDate le ${filterEnd.toISOString()} and EndDate ge ${filterStart.toISOString()}&$orderby=StartDate asc`;
          }
        } 
        else {
          const fs = (filterStart || startOfMonth(r.value)).toISOString();
          const fe = (filterEnd ? endOfDay(filterEnd) : endOfMonth(r.value)).toISOString();
          inProgressQuery = `$filter=StartDate le ${fe} and EndDate ge ${fs}&$orderby=StartDate asc`;
        }

        try {
          const abosRes = await Abo.getAll(inProgressQuery); 
          setAbos(abosRes);
        } catch (e) {
          showMessage({
            type: "error",
            text: 'Error while loading tasks: ' + JSON.stringify(e)
          });
        } 
        showSpinner(false);
      })
    }
    return (
      <>
        <AboList abos={filter(abos)} recentlyLinked={recentlyLinked} />
        {spinner && <Spinner />}
      </>
    );
}